module.exports = __webpack_public_path__ + "media/images/sample/product-2-8b34b112090f2027d05555605db6119f.png";